// consts
import { TYPE } from 'app/config/prescription_content';
import { ITEM } from 'app/config/prescription_item';
// utils
import _ from 'lodash';

export class PadPrescriptionType {
  constructor({ screenData, loadedData }) {
    this._screenData = screenData;
    this._loadedData = loadedData;
  }

  getTypeOnAdd(padPrescription) {
    const { code } = padPrescription;
    const screenData = [...this._screenData];
    const loadedData = [...this._loadedData];

    const padPrescriptionOnScreen = screenData.find(
      padPrescription => padPrescription.code === code
    );

    const padPrescriptionOnLoaded = loadedData.find(
      padPrescription => padPrescription.code === code
    );

    if (!padPrescriptionOnScreen || !padPrescriptionOnLoaded) {
      return TYPE.CREATED;
    }
  }

  _getForms = (padPrescriptionOnLoaded = {}, padPrescription = {}) => {
    const { DIET, MEDICAMENT, PROCEDURE } = ITEM;

    const formMap = {
      [DIET]: {
        preloadedPadPrescription: {
          ...padPrescriptionOnLoaded.prescriptionTypeForm,
          ...padPrescriptionOnLoaded.dietForm
        },
        currentPadPrescription: {
          ...padPrescription.prescriptionTypeForm,
          ...padPrescription.dietForm
        }
      },
      [MEDICAMENT]: {
        preloadedPadPrescription: {
          ...padPrescriptionOnLoaded.prescriptionTypeForm,
          ...padPrescriptionOnLoaded.medicamentForm
        },
        currentPadPrescription: {
          ...padPrescription.prescriptionTypeForm,
          ...padPrescription.medicamentForm
        }
      },
      [PROCEDURE]: {
        preloadedPadPrescription: {
          ...padPrescriptionOnLoaded.prescriptionTypeForm,
          ...padPrescriptionOnLoaded.procedureForm,
          ...padPrescriptionOnLoaded.procedureKitForm
        },
        currentPadPrescription: {
          ...padPrescription.prescriptionTypeForm,
          ...padPrescription.procedureForm,
          ...padPrescription.procedureKitForm
        }
      }
    };

    return formMap[padPrescription.prescriptionTypeForm.prescriptionType];
  };

  getTypeOnUnsuspend(padPrescription) {
    const { code } = padPrescription;
    // const screenData = [...this._screenData];
    const loadedData = [...this._loadedData];

    const padPrescriptionOnLoaded = loadedData.find(
      padPrescription => padPrescription.code === code
    );

    const { preloadedPadPrescription, currentPadPrescription } = this._getForms(
      padPrescriptionOnLoaded,
      padPrescription
    );

    if (preloadedPadPrescription.period !== currentPadPrescription.period) {
      return TYPE.CHANGED_PERIOD;
    } else if (
      JSON.stringify(preloadedPadPrescription) !== JSON.stringify(currentPadPrescription)
    ) {
      return TYPE.CHANGED;
    } else {
      return TYPE.SUSTEINED;
    }
  }

  getTypeOnEdit(padPrescription) {
    const { code } = padPrescription;
    // const screenData = [...this._screenData];
    const loadedData = [...this._loadedData];

    const padPrescriptionOnLoaded = loadedData.find(
      padPrescription => padPrescription.code === code
    );

    const { preloadedPadPrescription, currentPadPrescription } = this._getForms(
      padPrescriptionOnLoaded,
      padPrescription
    );

    const isPrescriptionPreExisting = !_.isEmpty(preloadedPadPrescription);

    if (!isPrescriptionPreExisting) {
      return TYPE.CREATED;
    }

    if (isPrescriptionPreExisting) {
      const hasPeriodChanged = preloadedPadPrescription.period !== currentPadPrescription.period;

      const hasAnythingElseChanged =
        JSON.stringify(preloadedPadPrescription) !== JSON.stringify(currentPadPrescription);

      if (hasPeriodChanged) {
        return TYPE.CHANGED_PERIOD;
      } else if (hasAnythingElseChanged) {
        return TYPE.CHANGED;
      } else {
        return TYPE.SUSTEINED;
      }
    }
  }
}
